import { render, staticRenderFns } from "./HodRegistrationFlowLayout.vue?vue&type=template&id=601fb47a&scoped=true&"
import script from "./HodRegistrationFlowLayout.vue?vue&type=script&lang=ts&"
export * from "./HodRegistrationFlowLayout.vue?vue&type=script&lang=ts&"
import style0 from "./HodRegistrationFlowLayout.vue?vue&type=style&index=0&id=601fb47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601fb47a",
  null
  
)

export default component.exports